import "./mobile-menu";
import "./gsap-animation";
import "./gsap-about";
import "./popup";
import "./gsap-technology";
import "./gsap-portal";
import "./contact-page";
import "./video-js";
// import "./product-tour.js";
// import "./anim-map";
// import "./gsap-map"; 

// import "./truck-3d-modal";
document.addEventListener("DOMContentLoaded", function () {

  setTimeout(() => {
    const hasWpcf7 = document.querySelector(".wpcf7") !== null;

    if (hasWpcf7) {
      new SS_Select(".wpcf7-select");
    }
  }, 1000);
  function replaceTagsBasedOnWidth() {
    const widthThreshold = 991;
    const ourTeamCards = document.querySelectorAll(".our-team-card");

    ourTeamCards.forEach((card) => {
      let cardUrl = card.getAttribute("data-url");

      if (window.innerWidth <= widthThreshold) {
        if (card.tagName.toLowerCase() === "a") {
          const newDiv = document.createElement("div");
          newDiv.className = card.className;
          newDiv.innerHTML = card.innerHTML;
          newDiv.setAttribute("data-url", cardUrl);
          card.parentNode.replaceChild(newDiv, card);

          const linkedInDiv = newDiv.querySelector(".our-team-card-linkedin");
          if (linkedInDiv && linkedInDiv.tagName.toLowerCase() === "div") {
            const newLink = document.createElement("a");
            newLink.className = linkedInDiv.className;
            newLink.href = cardUrl;
            newLink.target = "_blank";
            newLink.innerHTML = linkedInDiv.innerHTML;
            linkedInDiv.parentNode.replaceChild(newLink, linkedInDiv);
          }
        }
      } else {
        if (card.tagName.toLowerCase() === "div") {
          const newLink = document.createElement("a");
          newLink.className = card.className;
          newLink.href = cardUrl || "#";
          newLink.target = "_blank";
          newLink.innerHTML = card.innerHTML;
          newLink.setAttribute("data-url", cardUrl);
          card.parentNode.replaceChild(newLink, card);

          const linkedInLink = newLink.querySelector(".our-team-card-linkedin");
          if (linkedInLink && linkedInLink.tagName.toLowerCase() === "a") {
            const newDiv = document.createElement("div");
            newDiv.className = linkedInLink.className;
            newDiv.innerHTML = linkedInLink.innerHTML;
            linkedInLink.parentNode.replaceChild(newDiv, linkedInLink);
          }
        }
      }
    });
  }

  replaceTagsBasedOnWidth();

  window.addEventListener("resize", replaceTagsBasedOnWidth);

  // Tabs Functions --------------------------------
  const ElementsTabsContent = (ButtonTab, ItemTab) => {
    const tabs = document.querySelectorAll(ButtonTab);
    const tabItems = document.querySelectorAll(ItemTab);

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        const dataAttr = this.getAttribute("data-tabs");

        tabs.forEach((i) => i.classList.remove("active"));
        this.classList.add("active");

        tabItems.forEach((i) => i.classList.remove("active"));

        tabItems.forEach((i) => {
          if (i.getAttribute("data-tabs") === dataAttr) {
            i.classList.add("active");
          }
        });
      });
    });
  };

  ElementsTabsContent(
    ".tech-overview__feature-tabs .button__tabs",
    ".tech-overview__feature-item"
  );
  ElementsTabsContent(
    ".our-truck-types__truck-tabs .button__tabs-truck",
    ".our-truck-types__truck-item"
  );

  /////////////////////////////////////////////////////////////////
  const buttons = document.querySelectorAll(".hero-section-buttons a");
  if (buttons) {
    buttons.forEach((button) => {
      button.addEventListener("mouseenter", () => {
        // Remove 'active' class from all buttons
        buttons.forEach((btn) => btn.classList.remove("active"));

        // Add 'active' class to the hovered button
        button.classList.add("active");
      });
    });
  }

  /////////////////////////////////////////////////////////////////

  const video = document.querySelector(
    ".video-interview-video.video-ver #interviewVideo"
  );
  const image = document.getElementById("interviewImage");
  const playPauseBtn = document.querySelector(
    ".video-interview-controls #interviewVideoBtn"
  );
  const videoContainer = document.querySelector(".video-interview-inner");
  const videoContainerW = document.querySelector(".video-interview-container");

  if (video) {
    // Set the initial video source using the data-preview-video attribute
    video.setAttribute("src", video.getAttribute("data-preview-video"));

    // Start playing the preview video when the page loads
    video.play().catch((error) => {
      console.log("Autoplay was prevented:", error);
    });

    playPauseBtn.addEventListener("click", () => {
      // Check if data-full-video is not empty, otherwise use data-preview-video
      const fullVideo = video.getAttribute("data-full-video");
      const videoSource = fullVideo
        ? fullVideo
        : video.getAttribute("data-preview-video");

      if (!video.paused) {
        videoContainerW.classList.add("opened");
        videoContainer.classList.add("opened");
        if (image) {
          image.style.display = "none";
        }
        // Switch to full video or stay with preview if full video is not available
        video.setAttribute("src", videoSource);
        video.setAttribute("controls", "");
        video.muted = false; // Unmute the video when play button is clicked
        video.play();
      }
    });

    video.addEventListener("click", () => {
      if (!video.paused) {
        videoContainerW.classList.remove("opened");
        videoContainer.classList.remove("opened");
        video.removeAttribute("controls");
        video.muted = true;
        if (image) {
          image.style.display = "block";
        }
        // Revert to preview video when clicking the video
        video.setAttribute("src", video.getAttribute("data-preview-video"));
        video.play();
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Initialize GSAP ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);
  if (document.querySelector(".carrier-management-cards")) {
    ScrollTrigger.create({
      trigger: ".carrier-management-cards",
      start: "-200px top",
      end: "bottom bottom",
      scrub: true,
      pin: ".fixed-image-container",
      pinSpacing: true, // To remove additional spacing that the pinning might create
      onUpdate: (self) => {
        // Get all the cards
        const cards = document.querySelectorAll(".carrier-management-card");
        const fixedImage = document.querySelector(
          "#carrier-management-scroll-image img"
        );

        // Loop through each card to check its position
        cards.forEach((card) => {
          const cardRect = card.getBoundingClientRect();
          const cardImage = card.querySelector(
            ".carrier-management-card-image img"
          );

          if (
            cardRect.top <= window.innerHeight / 2 &&
            cardRect.bottom >= window.innerHeight / 2 &&
            fixedImage.src !== cardImage.src
          ) {
            // Update the image src if the card is in view
            fixedImage.src = cardImage.src;
            fixedImage.sizes = cardImage.sizes;
            fixedImage.alt = cardImage.alt;
            fixedImage.title = cardImage.title;
            fixedImage.srcset = cardImage.srcset;
          }
        });
      },
    });

    if (window.innerWidth <= 1279) {
      const cards = document.querySelectorAll(".carrier-management-card");
      cards.forEach((element) => {
        ScrollTrigger.create({
          trigger: element,
          start: "top 85%", // Adjust this to control when the animation starts
          end: "bottom center",
          onEnter: () => {
            gsap
              .timeline()
              .to(element, {
                opacity: 1,
                duration: 0.5, // Animate opacity first
                ease: "power3.out",
              })
              .to(
                element,
                {
                  y: 0,
                  duration: 0.7, // Animate y after opacity
                  ease: "power3.out",
                },
                "-=0.3"
              ); // Overlap animations slightly (optional)
          },
        });
      });
    }
  }

  if (
    window.innerWidth >= 767 &&
    document.querySelector(".our-blog") &&
    document.querySelector(".our-blog-heading")
  ) {
    const blogHeight = document.querySelector(".our-blog").offsetHeight;
    const headingHeight =
      document.querySelector(".our-blog-heading").offsetHeight;

    ScrollTrigger.create({
      trigger: ".our-blog-heading",
      start: "-300px top",
      endTrigger: ".our-blog",
      end: `+=${blogHeight - headingHeight}`, // Ends the pinning before the entire section is scrolled
      scrub: true,
      pin: ".our-blog-heading",
      pinSpacing: false,
    });
  }

  if (document.querySelector(".side-by-side-cards")) {
    gsap.fromTo(
      ".side-by-side-cards",
      {
        opacity: 0,
        y: 50,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        onComplete: () => {
          const container = document.querySelector(".side-by-side-cards");
          container.style.transform = "";
          container.style.translate = "";
          container.style.rotate = "";
          container.style.scale = "";

          initScrollAnimations();
        },
      }
    );

    function initScrollAnimations() {
      let cards = gsap.utils.toArray(".side-by-side-cards-card");
      let stickDistance = 0;

      const header = document.getElementById("header");
      const headerOffset = header ? header.offsetHeight : 0;

      ScrollTrigger.create({
        trigger: cards[cards.length - 1],
        start: "top top",
        // додаємо anticipatePin для зменшення дьоргання при піні
        anticipatePin: 1,
      });

      cards.forEach((card, index) => {
        if (index === cards.length - 1) return;

        let scale = 1 - (cards.length - index - 1) * 0.05;

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: card,
            start: `top-=${headerOffset} top`,
            end: () => `+=${card.offsetHeight}`,
            pin: true,
            pinSpacing: false,
            scrub: 2, // робимо scrub більшим для повільнішої прокрутки
            anticipatePin: 1, // додаємо anticipatePin до кожного ScrollTrigger
            onEnter: () => {
              if (index > 0) {
                gsap.to(cards[index - 1], {
                  y: `-=${card.offsetHeight}`,
                  duration: 0.5,
                  ease: "power2.out",
                });
              }
            },
            onLeaveBack: () => {
              if (index > 0) {
                gsap.to(cards[index - 1], {
                  y: "+=${card.offsetHeight}",
                  duration: 0.5,
                  ease: "power2.out",
                });
              }
            },
          },
        });

        tl.to(card, {
          scale: scale,
          transformOrigin: "50% -150%",
          ease: "none",
        });
      });
    }
  }

  //for privacy table contents
  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href");

      if (targetId === "#" || targetId === "") {
        return;
      }

      if (
        this.classList.contains("leaflet-control-zoom-in") ||
        this.classList.contains("leaflet-control-zoom-out")
      ) {
        return;
      }

      if (targetId !== "#track_form") {
        e.preventDefault();

        const header = document.querySelector(".header"); // Adjust the selector to match your header
        const headerHeight = header ? header.offsetHeight + 10 : 200; // Get the height of the header, or default to 0

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - headerHeight, // Subtract the dynamic header height
            behavior: "smooth",
          });
        }
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
    const formCheckboxGroups = document.querySelectorAll('.form-contact__checkbox-fields');

  formCheckboxGroups.forEach(group => {
    const formCheckboxesItems = group.querySelectorAll('.wpcf7-list-item');

    formCheckboxesItems.forEach(item => {
      const input = item.querySelector('input[type="checkbox"]');
      const label = item.querySelector('.wpcf7-list-item-label');

      label.setAttribute('tabindex', '0');

      // Keyboard accessibility
      label.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          label.click();
        }
      });

      // Click handler
      label.addEventListener('click', function (e) {
        e.preventDefault();

        // Uncheck all checkboxes in the same group
        group.querySelectorAll('input[type="checkbox"]').forEach(i => {
          i.checked = false;
          i.closest('.wpcf7-list-item')?.classList.remove('checked');
        });

        // Check the clicked one
        input.checked = true;
        item.classList.add('checked');
        input.dispatchEvent(new Event('change'));
      });

      // Focus ring via visually hidden input
      input.addEventListener('focus', () => label.classList.add('focus-visible'));
      input.addEventListener('blur', () => label.classList.remove('focus-visible'));

      // Initial state
      if (input.checked) {
        item.classList.add('checked');
      }
    });
  });
  const elements = document.querySelectorAll(".anim-top-slow");

  elements.forEach((element) => {
    ScrollTrigger.create({
      trigger: element,
      start: "top 95%", // Adjust this to control when the animation starts
      end: "bottom center",
      onEnter: () => {
        gsap.timeline().to(element, {
          opacity: 1,
          y: 0,
          duration: 2, // Animate opacity first
          ease: "power3.out",
        });
      },
    });
  });

  /* Modal clicked Tracking form
  --------------------------------------------- */
const formTruckingPopup = document.querySelector("#track_form");
const trackingLink = document.querySelector('.menu-item.item-111 a[href="#track_form"]');
const trackingMenuItem = document.querySelector('.menu-item.item-111');
const input = document.getElementById("header_tracking_number");
const submitButton = formTruckingPopup?.querySelector("button");
const logInLink = document.querySelector('.menu-item a[href="https://portal.expediteall.com/"]');

let bodyClickListener = null;

if (formTruckingPopup && trackingLink) {
  trackingLink.addEventListener("click", event => {
    event.preventDefault();

    const isOpen = formTruckingPopup.classList.contains("open");

    if (isOpen) {
      closeForm();
      return;
    }

    openForm();
  });

  function openForm() {
    formTruckingPopup.classList.add("open");
    formTruckingPopup.setAttribute("aria-hidden", "false");
    formTruckingPopup.setAttribute("aria-modal", "true");
    trackingMenuItem.classList.add("current-menu-item");

    setTimeout(() => input?.focus(), 0);

    document.addEventListener("keydown", onEscClose);
    submitButton?.addEventListener("keydown", onSubmitTab);

    input?.addEventListener("keydown", onInputShiftTab);

    document.addEventListener("focusin", onFocusIn);

    bodyClickListener = event => {
      if (
        !formTruckingPopup.contains(event.target) &&
        !trackingLink.contains(event.target)
      ) {
        closeForm();
      }
    };

    document.body.addEventListener("click", bodyClickListener);
  }

  function closeForm() {
    formTruckingPopup.classList.remove("open");
    formTruckingPopup.setAttribute("aria-hidden", "true");
    formTruckingPopup.setAttribute("aria-modal", "false");
    trackingMenuItem.classList.remove("current-menu-item");

    document.removeEventListener("keydown", onEscClose);
    submitButton?.removeEventListener("keydown", onSubmitTab);
    input?.removeEventListener("keydown", onInputShiftTab);
    document.removeEventListener("focusin", onFocusIn);

    if (bodyClickListener) {
      document.body.removeEventListener("click", bodyClickListener);
      bodyClickListener = null;
    }
  }

  function onEscClose(event) {
    if (event.key === "Escape") {
      closeForm();
    }
  }

  function onSubmitTab(event) {
    if (event.key === "Tab" && !event.shiftKey && logInLink) {
      event.preventDefault();
      closeForm();
      logInLink.focus();
    }
  }

  function onInputShiftTab(event) {
    if (event.key === "Tab" && event.shiftKey) {
      event.preventDefault();
      closeForm();
      trackingLink.focus();
    }
  }

  function onFocusIn(event) {
    const target = event.target;

    if (
      !formTruckingPopup.contains(target) &&
      target !== trackingLink
    ) {
      closeForm();
    }
  }
}


  const elements_pp = document.querySelectorAll(
    ".tech-text__wrapper p, .tech-text__wrapper ul, .tech-text__wrapper h2,.tech-text__wrapper li, .tech-text__wrapper h3,.tech-text__wrapper ol"
  );

  elements_pp.forEach((element) => {
    if (element) {
      ScrollTrigger.create({
        trigger: element,
        start: "top 85%", // Adjust this to control when the animation starts
        end: "bottom center",
        onEnter: () => {
          gsap
            .timeline()
            .to(element, {
              opacity: 1,
              duration: 0.5, // Animate opacity first
              ease: "power3.out",
            })
            .to(
              element,
              {
                y: 0,
                duration: 0.7, // Animate y after opacity
                ease: "power3.out",
              },
              "-=0.3"
            ); // Overlap animations slightly (optional)
        },
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  new MoveLine({
    shell_selector: ".why-expedite__items-wrapper-top",
    direction: "to-down", // to-up, to-left, to-right
    speed: 0.5, // 1-10
    min_width: 767,
  });

  new MoveLine({
    shell_selector: ".why-expedite__items-wrapper-down",
    direction: "to-up", // to-up, to-left, to-right
    speed: 0.5, // 1-10
    min_width: 767,
  });

  new MoveLine({
    shell_selector: ".why-expedite__items-wrapper-mobile",
    direction: "to-up", // to-up, to-left, to-right
    speed: 0.5, // 1-10
    max_width: 766,
  });

  // ---- Testimonials

  new MoveLine({
    shell_selector: ".testimonials__content__desk",
    direction: "to-left", // to-up, to-left, to-right
    speed: 0.5, // 1-10
    min_width: 767,
  });

  new MoveLine({
    shell_selector: ".testimonials__content__mobile",
    direction: "to-down", // to-up, to-left, to-right
    speed: 0.5, // 1-10
    max_width: 766,
  });

  new MoveLine({
    shell_selector: ".brands-slider__content",
    direction: "to-left", // to-up, to-left, to-right
    speed: 0.5, // 1-10
  });
  new MoveLine({
    shell_selector: ".ticker-section__items",
    direction: "to-left", // to-up, to-left, to-right
    speed: 0.5, // 1-10
  });
});

const PAGES_URLS = document.querySelectorAll(
  ".privacy-policy .wpcf7-acceptance a"
);

function UrlPages(items) {
  if (items.length) {
    items.forEach((item) => {
      if (!item.href.includes("#")) {
        item.removeAttribute("href");
        item.setAttribute("href", "#");
      }
    });
  }
}

UrlPages(PAGES_URLS);

